import React, { useState, useEffect } from 'react';

import { ROUTE_HOME, ROUTE_MY_PROFILE } from 'routes';

import Drawer from 'components/atoms/Drawer/Drawer';
import Box from 'components/atoms/Box/Box';

import {
  IconClose,
  LogoLifenome,
  AppsIcon,
  MyAccountIcon,
  LogoutIcon,
} from 'assets/iconsList';
import IconButton from 'components/molecules/IconButton/IconButton';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';
import Typography from 'components/atoms/Typography/Typography';
import { Trans } from 'react-i18next';

import { getSideMenuData } from 'helpers/sideMenuDataHelper';

import { useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function SideMenu(props) {
  const sideMenuData = getSideMenuData();
  const [open, setOpen] = useState(false);
  const [menuItems, setMenuItems] = useState(sideMenuData.routes);
  const [selectedMenuItem, setSelectedMenuItem] = useState(undefined);
  const [selectedSubMenuItem, setSelectedSubMenuItem] = useState(undefined);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const { PUBLIC_URL } = process.env;

  useEffect(() => {
    setOpen(props.opened);
  }, [props.opened]);

  useEffect(() => {
    props.handleOpened(open);
  }, [open]);

  const goToRoute = (route) => {
    let url = `${window.location.origin}${PUBLIC_URL}${route}`;
    window.open(url, '_self', 'noopener,noreferrer');
  };

  const handleLinkClick = (item) => {
    if (item.route === ROUTE_MY_PROFILE || item.route === ROUTE_HOME) {
      goToRoute(item.route);
    } else if (!item.subsections) {
      matches && setOpen(false);
      goToRoute(item.route);
    }
  };

  const renderMenuHeader = () => {
    return (
      <Box
        display="flex"
        justifyContent="space-between"
        style={{ height: 80, padding: '0 1rem 0 1rem' }}
      >
        <Box
          style={{
            width: 38,
            height: 34,
            backgroundColor: '#33b0ce',
            padding: 10,
            borderRadius: '0 0 5px 5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            window.open('https://www.lifenome.com/', '_blank');
            setOpen(false);
          }}
        >
          <LogoLifenome fill="#fff" />
        </Box>
        <Box
          style={{
            width: 38,
            height: 34,
            padding: 10,
          }}
        >
          <IconButton
            onButtonClick={() => {
              setOpen(false);
              setSelectedMenuItem(undefined);
              setSelectedSubMenuItem(undefined);
            }}
          >
            <IconClose fill="#33b0ce" />
          </IconButton>
        </Box>
      </Box>
    );
  };

  const renderSectionsMenu = () => {
    return (
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {menuItems &&
          menuItems.map((item, index) => {
            return (
              <>
                <MenuItem
                  text={
                    item.translationKey ? (
                      <Trans i18nKey={item.translationKey} />
                    ) : (
                      item.name
                    )
                  }
                  color={item.color}
                  selected={selectedMenuItem === item.id}
                  icon={
                    selectedMenuItem === item.id ? item.iconSelect : item.icon
                  }
                  onClick={() => {
                    setSelectedMenuItem(
                      selectedMenuItem === item.id ? undefined : item.id
                    );
                    setSelectedSubMenuItem(undefined);
                    handleLinkClick(item);
                  }}
                />

                {selectedMenuItem === item.id &&
                  item.subsections &&
                  item.subsections.map((subItem, index) => {
                    return (
                      <SubMenuItem
                        text={
                          subItem.translationKey ? (
                            <Trans i18nKey={subItem.translationKey} />
                          ) : (
                            subItem.name
                          )
                        }
                        color={item.color}
                        selected={selectedSubMenuItem === subItem.id}
                        icon={
                          selectedSubMenuItem === subItem.id
                            ? subItem.iconSelect
                            : subItem.icon
                        }
                        onClick={() => {
                          setSelectedSubMenuItem(subItem.id);
                          handleLinkClick(subItem);
                        }}
                      />
                    );
                  })}
              </>
            );
          })}
      </Box>
    );
  };

  const renderAppMenu = () => {
    return (
      <Box
        style={{ display: 'flex', flexDirection: 'column', marginTop: '50px' }}
      >
        <Box style={{ borderBottom: '1px solid #d6d6d6' }} />
        <SubMenuItem
          text={'My profile'}
          selected={selectedMenuItem === menuItems.length}
          icon={IconClose}
          onClick={() => {
            goToRoute(ROUTE_MY_PROFILE);
          }}
        />
        {/* <SubMenuItem
          text={'My Account'}
          selected={selectedMenuItem === menuItems.length + 1}
          icon={MyAccountIcon}
          onClick={() => {
            setSelectedMenuItem(
              selectedMenuItem === menuItems.length + 1
                ? undefined
                : menuItems.length
            );
            setSelectedSubMenuItem(undefined);
          }}
        /> */}
        <SubMenuItem
          text={'Logout'}
          selected={selectedMenuItem === menuItems.length + 2}
          icon={LogoutIcon}
          onClick={props.onSignOutClick}
        />

        <Box style={{ borderBottom: '1px solid #d6d6d6' }} />

        <SubMenuItem
          text={'Apps'}
          selected={selectedMenuItem === menuItems.length + 3}
          icon={AppsIcon}
          onClick={() => {
            window.open('https://demo.lifenome.com/', '_blank');
            setOpen(false);
          }}
        />

        <Box style={{ borderBottom: '1px solid #d6d6d6' }} />

        <SubMenuItem
          text={'About LifeNome'}
          selected={selectedMenuItem === menuItems.length + 4}
          onClick={() => {
            window.open('https://www.lifenome.com/about/', '_blank');
            setOpen(false);
          }}
        />
        <SubMenuItem
          text={'Terms of Service'}
          selected={selectedMenuItem === menuItems.length + 4}
          onClick={() => {
            window.open('https://www.lifenome.com/terms-of-service/', '_blank');
            setOpen(false);
          }}
        />
        <SubMenuItem
          text={'Legal'}
          selected={selectedMenuItem === menuItems.length + 4}
          onClick={() => {
            window.open('https://www.lifenome.com/privacy-policy/', '_blank');
            setOpen(false);
          }}
        />
      </Box>
    );
  };

  return (
    <Drawer
      anchor={props.anchor}
      drawerWidth="400px"
      variant="persistent"
      open={open}
      backgroundColor="#fff"
    >
      <Box style={{ height: 'calc(100vh - 85px)' }}>
        {renderMenuHeader()}

        <Box style={{ borderBottom: '1px solid #d6d6d6' }} />

        <Box
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          {renderSectionsMenu()}
          {renderAppMenu()}
        </Box>

        {/* <Box display="flex" justifyContent="flex-end">
          <Button onClick={props.onSignOutClick}>
            <Typography variant="h2" className={classes.linkText}>
              <Trans i18nKey="dna24.signOut" />
            </Typography>
          </Button>
        </Box> */}
      </Box>
    </Drawer>
  );
}

export function MenuItem(props) {
  const { text, selected, color, icon } = props;
  return (
    <Box
      style={{
        height: 50,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: selected ? color : '#fff',
        borderBottom: '0.5px solid #d6d6d6',
        cursor: 'pointer',
      }}
      onClick={() => {
        props.onClick && props.onClick();
      }}
    >
      <Box
        style={{
          marginLeft: '20px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {icon && (
          <SvgIcon
            style={{ marginRight: '10px' }}
            width={{ xs: '25px', sm: '28px', md: '30px', lg: '35px' }}
            icon={icon}
          />
        )}

        <Typography
          variant="body1"
          style={{
            color: selected ? '#fff' : '#2a343f',
            textTransform: 'uppercase',
            fontSize: '1rem',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
}

export function SubMenuItem(props) {
  const { text, selected, color, icon } = props;
  return (
    <Box
      style={{
        height: '40px',
        margin: '0 20px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: selected ? `4px solid ${color}` : '0.5px solid #d6d6d6',
        cursor: 'pointer',
      }}
      onClick={() => {
        props.onClick && props.onClick();
      }}
    >
      <Box
        style={{
          marginLeft: '20px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {icon && (
          <SvgIcon
            style={{ marginRight: '10px' }}
            width={{ xs: '15px', sm: '20px', md: '22px', lg: '25px' }}
            icon={icon}
          />
        )}

        <Typography
          variant="body2"
          style={{
            color: selected ? color : '#2a343f',
            fontSize: '1rem',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
}
